// src/pages/AuthCallbackPage.tsx
import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const AuthCallbackPage: React.FC = () => {
    useEffect(() => {
        // This effect runs inside the popup window after Google redirects.
        console.log('AuthCallbackPage loaded in popup.');

        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const error = params.get('error');

        if (window.opener) {
            if (code) {
                // Send the successful authorization code to the parent window
                console.log('Sending success message to opener with code.');
                window.opener.postMessage({ type: 'oauth_success', code: code }, window.location.origin);
            } else if (error) {
                // Send the error information to the parent window
                console.log('Sending error message to opener.');
                window.opener.postMessage({ type: 'oauth_error', error: error }, window.location.origin);
            }
        } else {
            console.error('No window.opener found. This page should be opened as a popup.');
        }

        // Close the popup window
        window.close();

    }, []); // Empty dependency array ensures this runs only once on mount

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
            }}
        >
            <CircularProgress />
            <Typography sx={{ mt: 2 }}>Authenticating, please wait...</Typography>
        </Box>
    );
};

export default AuthCallbackPage;